import React, { useEffect, useState } from "react";
import style from "./MilestoneProgressBar.module.scss";
import classNames from "classnames";
import TrackBarIcon from "./TrackbarIcon";
import { Box, Typography } from "@mui/material";

interface IDetailMilestone {
    progress: number;
}

interface IMilestoneProgressBar {
    data: Array<IDetailMilestone>;
    percentProcess: number;
    isShowLabel?: boolean;
    isReachedMaxLevel?: boolean;
    nextLevelName?: string;
    gameUserLevel?: any;
}

const MilestoneProgressBar = ({
    data,
    percentProcess,
    isShowLabel = false,
    isReachedMaxLevel = false,
    nextLevelName = "",
    gameUserLevel
}: IMilestoneProgressBar) => {
    return (
        <div className={style["MilestoneProgressBar"]}>
            <div className={style["hightLevelProress"]}>
                {data.map((item: IDetailMilestone, index: number) => {
                    return (
                        <div
                            className={classNames(
                                style["progressBarWrapper"],
                                index === data.length - 1
                                    ? style["lastProgressBar"]
                                    : "",
                                index === 0 ? style["firstProgressBar"] : "",
                                item.progress > 0
                                    ? style["activeProgressBar"]
                                    : ""
                            )}
                            key={index}
                        >
                            <div
                                className={classNames(style["progress"])}
                                style={{ width: `${item.progress}%` }}
                            >
                                <div
                                    className={classNames(
                                        style["progress2"],
                                        "progress2"
                                    )}
                                    style={{ width: `100%` }}
                                ></div>
                            </div>
                            <div
                                className={classNames(
                                    style["non-progress"],
                                    "non-progress"
                                )}
                                style={{ width: `${100 - item.progress}%` }}
                            />
                        </div>
                    );
                })}
                <div
                    className={style["trackBar"]}
                    style={{
                        left: `calc(${percentProcess}% - 4px)`,
                    }}
                ></div>
            </div>
            {isShowLabel && (
                <Box
                    sx={{
                        marginTop: "12px",
                        padding: "24px",
                        backgroundColor: "#e6e6e6",
                        whiteSpace: "nowrap",
                        borderRadius: "12px",
                        textAlign: "center",
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "GRIFTER",
                            fontSize: "18px",
                            lineHeight: "20px",
                            color: "#161616",
                            textTransform: "uppercase",
                            fontWeight: 700,
                        }}
                    >
                        {percentProcess}% TO {nextLevelName}
                    </Typography>
                    {Boolean(!isReachedMaxLevel) && (
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "20px",
                                color: "#161616",
                                marginTop: "8px",
                            }}
                        >
                              {gameUserLevel && gameUserLevel?.remaining.hour > 0
                                ? `${gameUserLevel?.remaining.hour} ${
                                      gameUserLevel?.remaining.hour > 1
                                          ? "hours"
                                          : "hour"
                                  } `
                                : ""}
                            {gameUserLevel
                                ? `${gameUserLevel?.remaining.minute} ${
                                      gameUserLevel?.remaining.minute > 1
                                          ? "minutes"
                                          : "minute"
                                  } `
                                : ""}{" "}to Level Up
                        </Typography>
                    )}
                </Box>
            )}
        </div>
    );
};

export default MilestoneProgressBar;
